import { useLocation, useNavigate } from 'react-router-dom';
import { useRef, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../../../../component/BreadCrumb';
import {
    CODE_GROUP_ID,
    COMMUNITY_FAQ_ADD_PATH,
    COMMUNITY_FAQ_DETAIL_PATH,
    PATH_DELIMITER,
    ROLE,
} from '../../../../constant/Constant';
import InputBox from '../../../../component/InputBox';
import RegistButtonBox from '../../../../component/buttons/RegistButtonBox';
import { actionSearch } from '../../../../module/body/community/faq/CommunityFaqModule';
import { VIEW_COMMUNITY_FAQ } from '../../../../constant/ViewConstant';
import SearchButtonBox from '../../../../component/buttons/SearchButtonBox';
import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import CodeUtil from '../../../../util/CodeUtil';
import { defaultGridData, handleControl, initGrid } from '../../../../module/component/TableBoxModule';
import TableBox from '../../../../component/TableBox';
import ModalRef from '../../../../component/ModalRef';
import PopupRef from '../../../../component/PopupRef';
import { IconButton, Tooltip } from '@material-ui/core';
import { OpenDetailIcon } from '../../../../component/icon/GridIcons';
import PathUtil from '../../../../util/PathUtil';
import qs from 'qs';
import NullCheckUtil from '../../../../util/NullCheckUtil';

const ConditionArea = ({ popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const addPermission =
        NullCheckUtil.isNotEmpty(AuthenticationUtil.getUserRoleCd()) &&
        (AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN || AuthenticationUtil.getUserRoleCd() == ROLE.STAFF);
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [params, setParams] = useState({});

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const { gridData } = useSelector((state) => state.tableBoxState);

    // 최초 초기화 호출
    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.postingTitleNm && setPostingTitleNm(queryData.postingTitleNm);

        onClickSearch({
            postingTitleNm: queryData.postingTitleNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 10,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({ postingTitleNm, page, pageSize });
    };

    // button action - search
    const onClickSearch = (params) => {
        setParams(params);
        dispatch(
            actionSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, params);
    };
    const onRowDoubleClick = (row, params) => {
        var path = COMMUNITY_FAQ_DETAIL_PATH + PATH_DELIMITER + row.postingNo;
        navigate(path);
    };

    // action - add
    const handleAdd = () => {
        navigate(COMMUNITY_FAQ_ADD_PATH);
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({ postingTitleNm, page: defaultGridData.page, pageSize: gridData.pageSize });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'postingNo',
                headerName: '번호',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 3,
            },
            {
                field: 'postingTitleNm',
                headerName: '제목',
                headerAlign: 'center',
                align: 'left',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userUniversityCd',
                headerName: '담당대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 3,
                renderCell: (params) => {
                    params.row.userUniversityCd &&
                        CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, params.row.userUniversityCd);
                },
            },
            {
                field: 'userNm',
                headerName: '작성자',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 3,
            },
            {
                field: 'regDttm',
                headerName: '등록일',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 5,
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 2,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params, gridData],
    );

    return (
        <>
            <div className='con-form-wrap '>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='search-condition-box'>
                                <div className='form-box-container'>
                                    <InputBox
                                        title='제목'
                                        value={postingTitleNm}
                                        onChange={(e) => setPostingTitleNm(e.target.value)}
                                        size='w-420'
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                </div>
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            postingTitleNm,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title'>
                    <h3 className='tb-tit-name'>FAQ 목록</h3>
                    {addPermission && <RegistButtonBox title='등록' btnCommon onClick={(e) => handleAdd()} />}
                </div>
            </div>
        </>
    );
};

const CommunityFaqView = () => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg02'>
                    <h2 className='con-title'>{VIEW_COMMUNITY_FAQ.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_FAQ.subTitle}</p>
                    {/* <h2 className='con-title'>FAQ</h2> */}
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <ConditionArea popupRef={popupRef} modalRef={modalRef} />
                <TableBox isSupportedWide={false} />
            </div>
            <ModalRef ref={modalRef} />
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityFaqView;
